
const LINE_COLOR = '#40A1E1';
const DATA_LIST = [];

const DEFAULT_OPTION = {
    animation: false,
    grid: {
        left: 40,
        top: 10,
        right: 30,
        bottom: 35,
    },
    xAxis: {
        type: 'time',
        // data: xData,
        axisLine: {
            // show: false,
            lineStyle: {
                color: 'rgba(0,0,0,0.2)',
            },
        },
        axisLabel: {
            // show: false,
            fontSize: 11,
            color: 'rgba(0,0,0,0.8)',
        },
    },
    yAxis: [{
        type: 'value',
        position: 'left',
        scale: true,// true时不一定显示0
        axisLine: {
            // show: false,
            lineStyle: {
                color: 'rgba(0,0,0,0.2)',
            },
        },
        splitLine: {
            lineStyle: {
                color: 'rgba(0,0,0,0.2)',
            },
        },
        axisLabel: {
            // show: false,
            fontSize: 11,
            color: 'rgba(0,0,0,0.8)',
        },
    }, {
        type: 'value',
        position: 'right',
        scale: true,// true时不一定显示0
        axisLine: {
            // show: false,
            lineStyle: {
                color: 'rgba(0,0,0,0.2)',
            },
        },
        splitLine: {
            lineStyle: {
                color: 'rgba(0,0,0,0.2)',
            },
        },
        axisLabel: {
            // show: false,
            fontSize: 11,
            color: 'rgba(0,0,0,0.8)',
        },
    }],
    series: [
        {
            data: DATA_LIST,
            // data: yData,
            type: 'line',
            itemStyle: {
                color: LINE_COLOR,
            },
            yAxisIndex: 0,
            symbol: 'none',
            // lineStyle: {
            //     width: lineW,
            // },
        },
    ],
};

export {
    DEFAULT_OPTION,
};